import { render } from "./App.vue?vue&type=template&id=22e15ef0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=22e15ef0&lang=scss"

import exportComponent from "E:\\Gitlab\\02_各园区PC端\\happyHarbour\\ningbo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__